export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";